// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var Fetch = require("bs-fetch/src/Fetch.res.js");
var React = require("react");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Js_promise = require("rescript/lib/js/js_promise.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var JsxRuntime = require("react/jsx-runtime");
var Http$ReactHooksTemplate = require("../common/http.res.js");
var Image$ReactHooksTemplate = require("../common/image.res.js");
var Utils$ReactHooksTemplate = require("../common/utils.res.js");
var FeedFile$ReactHooksTemplate = require("./feedFile.res.js");
var AuthProvider$ReactHooksTemplate = require("../AuthProvider.res.js");
var Distribution$ReactHooksTemplate = require("./distribution.res.js");
var Notification$ReactHooksTemplate = require("../common/Notification.res.js");
var DistributionCreate$ReactHooksTemplate = require("./DistributionCreate.res.js");

var initialState = {
  loading: true,
  distributions: /* [] */0,
  notification: undefined,
  distributionCreate: false
};

function reducer(state, x) {
  if (typeof x === "object") {
    if (x.TAG === "FetchDistributionsCompleted") {
      return {
              loading: false,
              distributions: x._0,
              notification: state.notification,
              distributionCreate: state.distributionCreate
            };
    } else {
      return {
              loading: state.loading,
              distributions: state.distributions,
              notification: x._0,
              distributionCreate: state.distributionCreate
            };
    }
  }
  switch (x) {
    case "FetchDistributionInProgress" :
        return {
                loading: true,
                distributions: state.distributions,
                notification: state.notification,
                distributionCreate: state.distributionCreate
              };
    case "RemoveNotification" :
        return {
                loading: state.loading,
                distributions: state.distributions,
                notification: undefined,
                distributionCreate: state.distributionCreate
              };
    case "ToggleDistributionCreate" :
        return {
                loading: state.loading,
                distributions: state.distributions,
                notification: state.notification,
                distributionCreate: !state.distributionCreate
              };
    
  }
}

function DistributionList(props) {
  var campaignId = props.campaignId;
  var match = React.useReducer(reducer, initialState);
  var dispatch = match[1];
  var state = match[0];
  var match$1 = React.useContext(AuthProvider$ReactHooksTemplate.authContext);
  var toggleDistributionCreate = function (option) {
    Curry._1(dispatch, "ToggleDistributionCreate");
    if (option === "save") {
      Js_promise.then_((function (distributions) {
              Curry._1(dispatch, {
                    TAG: "FetchDistributionsCompleted",
                    _0: distributions
                  });
              return Promise.resolve();
            }), Js_promise.then_((function (json) {
                  return Promise.resolve(Json_decode.field("distributions", (function (param) {
                                    return Json_decode.list(Distribution$ReactHooksTemplate.decode, param);
                                  }), json));
                }), Js_promise.then_((function (response) {
                      return Fetch.$$Response.json(response);
                    }), fetch("/api/v1/campaigns/" + campaignId + "/distributions", Fetch.RequestInit.make("Get", undefined, undefined, undefined, undefined, undefined, "SameOrigin", undefined, undefined, undefined, undefined, undefined)()))));
      return ;
    }
    
  };
  React.useEffect((function (param) {
          Js_promise.then_((function (distributions) {
                  Curry._1(dispatch, {
                        TAG: "FetchDistributionsCompleted",
                        _0: distributions
                      });
                  return Promise.resolve();
                }), Js_promise.then_((function (json) {
                      return Promise.resolve(Json_decode.field("distributions", (function (param) {
                                        return Json_decode.list(Distribution$ReactHooksTemplate.decode, param);
                                      }), json));
                    }), Js_promise.then_((function (response) {
                          return Fetch.$$Response.json(response);
                        }), fetch("/api/v1/campaigns/" + campaignId + "/distributions", Fetch.RequestInit.make("Get", undefined, undefined, undefined, undefined, undefined, "SameOrigin", undefined, undefined, undefined, undefined, undefined)()))));
        }), []);
  var removeNotification = function (param) {
    Curry._1(dispatch, "RemoveNotification");
  };
  var bgSourceStatusColor = function (status) {
    switch (status) {
      case "pending" :
          return "bg-candypink";
      case "processed" :
          return "bg-americangreen";
      case "processing" :
          return "bg-cobalt";
      default:
        return "hidden";
    }
  };
  var bgStatusColor = function (status) {
    switch (status) {
      case "finished" :
          return "bg-americangreen";
      case "paused" :
          return "bg-lavenderblush";
      case "pending" :
          return "bg-candypink";
      case "running" :
          return "bg-cobalt";
      case "scheduled" :
          return "bg-yellow-400";
      case "stopped" :
          return "bg-firebrick";
      default:
        return "hidden";
    }
  };
  if (state.loading) {
    return JsxRuntime.jsx("p", {
                children: "Loading distributions..."
              });
  }
  var notification = state.notification;
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [
                notification !== undefined ? JsxRuntime.jsx(Notification$ReactHooksTemplate.make, {
                        text: notification,
                        handleClose: removeNotification
                      }) : JsxRuntime.jsx(JsxRuntime.Fragment, {}),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx("h2", {
                                      children: "Distributions",
                                      className: "text-xl font-semibold"
                                    }),
                                JsxRuntime.jsx("div", {
                                      children: Curry._1(match$1[0], "CreateDistribution") ? JsxRuntime.jsxs("div", {
                                              children: [
                                                JsxRuntime.jsx("img", {
                                                      className: "h-14-px mr-2-px",
                                                      src: Image$ReactHooksTemplate.plusCircle
                                                    }),
                                                "New Distribution"
                                              ],
                                              className: "bg-ghostwhite border border-gray-400\n                    shadow-inner flex rounded py-2 px-3 text-xs cursor-pointer",
                                              id: "add-distribution",
                                              onClick: (function (param) {
                                                  Curry._1(dispatch, "ToggleDistributionCreate");
                                                })
                                            }) : JsxRuntime.jsx(JsxRuntime.Fragment, {}),
                                      className: "flex justify-end items-center"
                                    })
                              ],
                              className: "flex justify-between items-center p-20-px"
                            }),
                        JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsxs("table", {
                                    children: [
                                      JsxRuntime.jsx("thead", {
                                            children: JsxRuntime.jsxs("tr", {
                                                  children: [
                                                    JsxRuntime.jsx("th", {
                                                          children: JsxRuntime.jsxs("div", {
                                                                children: [
                                                                  "UID",
                                                                  JsxRuntime.jsx("img", {
                                                                        className: "ml-4-px",
                                                                        src: Image$ReactHooksTemplate.heading
                                                                      })
                                                                ],
                                                                className: "flex"
                                                              }),
                                                          className: "px-4 py-3"
                                                        }),
                                                    JsxRuntime.jsx("th", {
                                                          children: JsxRuntime.jsxs("div", {
                                                                children: [
                                                                  "Source Type",
                                                                  JsxRuntime.jsx("img", {
                                                                        className: "ml-4-px",
                                                                        src: Image$ReactHooksTemplate.heading
                                                                      })
                                                                ],
                                                                className: "flex"
                                                              }),
                                                          className: "px-4 py-3"
                                                        }),
                                                    JsxRuntime.jsx("th", {
                                                          children: JsxRuntime.jsxs("div", {
                                                                children: [
                                                                  "Source Detail",
                                                                  JsxRuntime.jsx("img", {
                                                                        className: "ml-4-px",
                                                                        src: Image$ReactHooksTemplate.heading
                                                                      })
                                                                ],
                                                                className: "flex"
                                                              }),
                                                          className: "px-4 py-3"
                                                        }),
                                                    JsxRuntime.jsx("th", {
                                                          children: JsxRuntime.jsxs("div", {
                                                                children: [
                                                                  "Source Status",
                                                                  JsxRuntime.jsx("img", {
                                                                        className: "ml-4-px",
                                                                        src: Image$ReactHooksTemplate.heading
                                                                      })
                                                                ],
                                                                className: "flex"
                                                              }),
                                                          className: "px-4 py-3"
                                                        }),
                                                    JsxRuntime.jsx("th", {
                                                          children: JsxRuntime.jsxs("div", {
                                                                children: [
                                                                  "Total",
                                                                  JsxRuntime.jsx("img", {
                                                                        className: "ml-4-px",
                                                                        src: Image$ReactHooksTemplate.heading
                                                                      })
                                                                ],
                                                                className: "flex"
                                                              }),
                                                          className: "px-4 py-3"
                                                        }),
                                                    JsxRuntime.jsx("th", {
                                                          children: JsxRuntime.jsxs("div", {
                                                                children: [
                                                                  "Status",
                                                                  JsxRuntime.jsx("img", {
                                                                        className: "ml-4-px",
                                                                        src: Image$ReactHooksTemplate.heading
                                                                      })
                                                                ],
                                                                className: "flex"
                                                              }),
                                                          className: "px-4 py-3"
                                                        }),
                                                    JsxRuntime.jsx("th", {
                                                          children: JsxRuntime.jsxs("div", {
                                                                children: [
                                                                  "Created At",
                                                                  JsxRuntime.jsx("img", {
                                                                        className: "ml-4-px",
                                                                        src: Image$ReactHooksTemplate.heading
                                                                      })
                                                                ],
                                                                className: "flex"
                                                              }),
                                                          className: "px-4 py-3"
                                                        }),
                                                    JsxRuntime.jsx("th", {
                                                          children: JsxRuntime.jsxs("div", {
                                                                children: [
                                                                  "Actions",
                                                                  JsxRuntime.jsx("img", {
                                                                        className: "ml-4-px",
                                                                        src: Image$ReactHooksTemplate.heading
                                                                      })
                                                                ],
                                                                className: "flex"
                                                              }),
                                                          className: "px-4 py-3"
                                                        })
                                                  ]
                                                }),
                                            className: "font-medium p-4 bg-ghostwhite text-aurometalsaurus"
                                          }),
                                      JsxRuntime.jsx("tbody", {
                                            children: $$Array.of_list(List.map((function (x) {
                                                        var y = Distribution$ReactHooksTemplate.customerSource(x);
                                                        var y$1 = Distribution$ReactHooksTemplate.customerSource(x);
                                                        var y$2 = y$1._0;
                                                        var y$3 = Distribution$ReactHooksTemplate.customerSource(x);
                                                        var match = Distribution$ReactHooksTemplate.status(x);
                                                        var tmp = match === "pending" ? JsxRuntime.jsx("input", {
                                                                className: "text-white text-sm bg-pigmentblue hover:bg-teal-800 py-1\n                                px-3 rounded w-80-px",
                                                                type: "button",
                                                                value: "Start",
                                                                onClick: (function (param) {
                                                                    param.preventDefault();
                                                                    var distributionId = String(Distribution$ReactHooksTemplate.id(x));
                                                                    var url = "/api/v1/distributions/" + distributionId + "/start";
                                                                    Js_promise.then_((function (response) {
                                                                            var status = Json_decode.field("status", (function (param) {
                                                                                    return Json_decode.withDefault("failed", Json_decode.string, param);
                                                                                  }), response);
                                                                            if (status === "success") {
                                                                              var distribution = Json_decode.field("distribution", Distribution$ReactHooksTemplate.decode, response);
                                                                              Curry._1(dispatch, {
                                                                                    TAG: "FetchDistributionsCompleted",
                                                                                    _0: Belt_List.map(state.distributions, (function (y) {
                                                                                            if (Distribution$ReactHooksTemplate.id(distribution) === Distribution$ReactHooksTemplate.id(y)) {
                                                                                              return distribution;
                                                                                            } else {
                                                                                              return y;
                                                                                            }
                                                                                          }))
                                                                                  });
                                                                              Curry._1(dispatch, {
                                                                                    TAG: "AddNotification",
                                                                                    _0: "Successfully started\n         distribution"
                                                                                  });
                                                                            } else {
                                                                              Curry._1(dispatch, {
                                                                                    TAG: "AddNotification",
                                                                                    _0: "Something went wrong. Please try\n         again later"
                                                                                  });
                                                                            }
                                                                            return Promise.resolve();
                                                                          }), Http$ReactHooksTemplate.fetchPostJSON(url, {}));
                                                                  })
                                                              }) : JsxRuntime.jsx(JsxRuntime.Fragment, {});
                                                        return JsxRuntime.jsxs("tr", {
                                                                    children: [
                                                                      JsxRuntime.jsx("td", {
                                                                            children: JsxRuntime.jsxs("div", {
                                                                                  children: [
                                                                                    JsxRuntime.jsx("div", {
                                                                                          children: JsxRuntime.jsx("div", {
                                                                                                children: Distribution$ReactHooksTemplate.uid(x)[0],
                                                                                                className: "m-auto"
                                                                                              }),
                                                                                          className: "w-8 h-8 flex items-center text-white uppercase mr-3 rounded-lg " + Utils$ReactHooksTemplate.randomBgColor()
                                                                                        }),
                                                                                    Distribution$ReactHooksTemplate.uid(x)
                                                                                  ],
                                                                                  className: "flex items-center"
                                                                                }),
                                                                            className: "px-4 py-3"
                                                                          }),
                                                                      JsxRuntime.jsx("td", {
                                                                            children: JsxRuntime.jsx("div", {
                                                                                  children: Distribution$ReactHooksTemplate.customerSourceType(x),
                                                                                  className: "text-xs px-3 py-2 rounded-2xl flex items-center\n                                        border border-gray-400 w-fit font-normal text-aurometalsaurus"
                                                                                }),
                                                                            className: "px-4 py-3"
                                                                          }),
                                                                      JsxRuntime.jsx("td", {
                                                                            children: JsxRuntime.jsx("div", {
                                                                                  children: FeedFile$ReactHooksTemplate.name(y._0),
                                                                                  className: "text-xs px-3 py-2 w-fit font-normal text-aurometalsaurus"
                                                                                }),
                                                                            className: "px-4 py-3"
                                                                          }),
                                                                      JsxRuntime.jsx("td", {
                                                                            children: JsxRuntime.jsxs("div", {
                                                                                  children: [
                                                                                    JsxRuntime.jsx("div", {
                                                                                          className: "h-3 w-3 rounded-full " + bgSourceStatusColor(FeedFile$ReactHooksTemplate.status(y$2))
                                                                                        }),
                                                                                    FeedFile$ReactHooksTemplate.status(y$2).toUpperCase()
                                                                                  ],
                                                                                  className: "text-xs px-3 py-2 rounded-2xl flex gap-1 items-center\n                                            border border-gray-400 w-fit font-normal text-aurometalsaurus"
                                                                                }),
                                                                            className: "px-4 py-3"
                                                                          }),
                                                                      JsxRuntime.jsx("td", {
                                                                            children: String(FeedFile$ReactHooksTemplate.count(y$3._0)),
                                                                            className: "px-4 py-3"
                                                                          }),
                                                                      JsxRuntime.jsx("td", {
                                                                            children: JsxRuntime.jsxs("div", {
                                                                                  children: [
                                                                                    JsxRuntime.jsx("div", {
                                                                                          className: "h-3 w-3 rounded-full " + bgStatusColor(Distribution$ReactHooksTemplate.status(x))
                                                                                        }),
                                                                                    Distribution$ReactHooksTemplate.status(x).toUpperCase()
                                                                                  ],
                                                                                  className: "text-xs px-3 py-2 rounded-2xl flex gap-1 items-center\n                                        border border-gray-400 w-fit font-normal text-aurometalsaurus"
                                                                                }),
                                                                            className: "px-4 py-3"
                                                                          }),
                                                                      JsxRuntime.jsx("td", {
                                                                            children: JsxRuntime.jsx("div", {
                                                                                  children: Distribution$ReactHooksTemplate.createdAt(x).format("lll"),
                                                                                  className: "text-xs px-3 py-2 rounded-2xl flex items-center\n                                    border border-gray-400 w-fit font-normal text-aurometalsaurus"
                                                                                }),
                                                                            className: "px-4 py-3"
                                                                          }),
                                                                      JsxRuntime.jsx("td", {
                                                                            children: tmp,
                                                                            className: "px-4 py-3"
                                                                          })
                                                                    ],
                                                                    className: "border-b border-bottom-gray-600"
                                                                  }, Distribution$ReactHooksTemplate.uid(x));
                                                      }), state.distributions))
                                          })
                                    ],
                                    className: "text-left table-auto w-full border-separate text-sm font-medium"
                                  }),
                              className: "flex px-20-px"
                            })
                      ]
                    }),
                state.distributionCreate ? JsxRuntime.jsx("div", {
                        children: JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsxs("div", {
                                      children: [
                                        JsxRuntime.jsx("div", {
                                              children: "Create New Distribution"
                                            }),
                                        JsxRuntime.jsx("img", {
                                              className: "h-14-px float-right cursor-pointer",
                                              src: Image$ReactHooksTemplate.closeIcon,
                                              onClick: (function (param) {
                                                  Curry._1(dispatch, "ToggleDistributionCreate");
                                                })
                                            })
                                      ],
                                      className: "p-8 text-lg font-bold flex justify-between"
                                    }),
                                JsxRuntime.jsx("div", {
                                      children: JsxRuntime.jsx(DistributionCreate$ReactHooksTemplate.make, {
                                            campaignId: campaignId,
                                            toggleDistributionCreate: toggleDistributionCreate
                                          }),
                                      className: "border-t border-gray-200 text-base font-medium h-432-px"
                                    })
                              ],
                              className: "bg-white modal-campaign z-10 shadow relative border border-gray-300 pointer-events-auto"
                            }),
                        className: "z-10 disabled-wrapper absolute inset-0 flex justify-center items-center",
                        style: {
                          height: "calc(100vh + 5rem)"
                        }
                      }) : JsxRuntime.jsx(JsxRuntime.Fragment, {})
              ]
            });
}

var make = DistributionList;

exports.initialState = initialState;
exports.reducer = reducer;
exports.make = make;
/* react Not a pure module */
